/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadMedicaidCaseResponseData } from './LeadMedicaidCaseResponseData';
import {
    LeadMedicaidCaseResponseDataFromJSON,
    LeadMedicaidCaseResponseDataFromJSONTyped,
    LeadMedicaidCaseResponseDataToJSON,
    LeadMedicaidCaseResponseDataToJSONTyped,
} from './LeadMedicaidCaseResponseData';

/**
 * 
 * @export
 * @interface LeadMedicaidCaseResponse
 */
export interface LeadMedicaidCaseResponse {
    /**
     * 
     */
    data: LeadMedicaidCaseResponseData;
}

/**
 * Check if a given object implements the LeadMedicaidCaseResponse interface.
 */
export function instanceOfLeadMedicaidCaseResponse(value: object): value is LeadMedicaidCaseResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function LeadMedicaidCaseResponseFromJSON(json: any): LeadMedicaidCaseResponse {
    return LeadMedicaidCaseResponseFromJSONTyped(json, false);
}

export function LeadMedicaidCaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadMedicaidCaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeadMedicaidCaseResponseDataFromJSON(json['data']),
    };
}

export function LeadMedicaidCaseResponseToJSON(json: any): LeadMedicaidCaseResponse {
    return LeadMedicaidCaseResponseToJSONTyped(json, false);
}

export function LeadMedicaidCaseResponseToJSONTyped(value?: LeadMedicaidCaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadMedicaidCaseResponseDataToJSON(value['data']),
    };
}

